import { render, staticRenderFns } from "./DiscountDelete.vue?vue&type=template&id=25a84bad&scoped=true"
import script from "./DiscountDelete.vue?vue&type=script&lang=js"
export * from "./DiscountDelete.vue?vue&type=script&lang=js"
import style0 from "./DiscountDelete.vue?vue&type=style&index=0&id=25a84bad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a84bad",
  null
  
)

export default component.exports